import { pb } from "./pocketbase";
import { bomService } from "./bomService";
import { isetSyncService } from "./isetSyncService";
import { financeiroIntegracaoService } from "./financeiroIntegracaoService";

export const reservationsService = {
  // --- 1. CONVERTER RESERVA EM PEDIDO (A Lógica Mestra) ---
  async convertToOrder(enrichedData) {
    console.log("🛠️ Iniciando Conversão (PocketBase). Dados:", enrichedData);

    // 1. Extrair metadados e limpar payload
    const {
      id: oldReservationId,
      stockItemId, // ID do item no estoque (se houver)
      fromStock,
      isInterceptedPE,
      ...dataToSave
    } = enrichedData;

    if (!oldReservationId) {
      throw new Error("ID da reserva original não encontrado.");
    }

    // 2. Criar a Ordem de Produção (PB)
    // Mapeamos o objeto "enrichedData" para o schema "production_orders"
    // O campo CRÍTICO é o "full_data" que vai guardar tudo para o React ler depois.
    const orderPayload = {
      status: dataToSave.status || "SOLICITACAO", // (FIX: Usa o status que veio do Modal/Dropdown)
      sku: dataToSave.sku,
      customer_name: dataToSave.order?.customer?.name || "Cliente Balcão",
      order_number: dataToSave.order?.number || "S/N",

      // Campos de Busca
      logistics_status: "SEM ETIQUETA",
      archived: false,
      certificatePrinted: false,
      shipping_city: dataToSave.shipping?.address?.city || "",
      shipping_state: dataToSave.shipping?.address?.state || "",

      // (FIX: Campo vital para funcionamento da data na lista de produção)
      customCreatedAt: dataToSave.customCreatedAt ? new Date(dataToSave.customCreatedAt) : new Date(),

      // JSONs Completos
      specs: { ...(dataToSave.specs || {}), exception: dataToSave.exception || "" }, // Salva exceção dentro do JSON specs para evitar falha no PocketBase
      full_data: {
        ...dataToSave,
        fromStock: !!fromStock,
        isInterceptedPE: !!isInterceptedPE,
        stockItemId: stockItemId || null,
        originalReservationId: oldReservationId,
        convertedAt: new Date(),
        createdAt: dataToSave.customCreatedAt ? new Date(dataToSave.customCreatedAt) : new Date(), // (FIX: Respeita data editada)
      },
      // (FIX: Garante que a data raiz também seja ajustada se o PB permitir override, senão fica no full_data)
      created: dataToSave.customCreatedAt ? new Date(dataToSave.customCreatedAt).toISOString() : undefined,
    };

    const newOrder = await pb.collection("production_orders").create(orderPayload);

    // Atualiza a origem do lançamento/pendência financeira no staging/ledger de "reservations" para "production_orders"
    try {
      await financeiroIntegracaoService.updateOrigemOnConversion(
        "reservations",
        oldReservationId,
        "production_orders",
        newOrder.id
      );
    } catch (errFin) {
      console.warn("Erro ao atualizar origem financeira na conversão:", errFin);
    }

    // Se a reserva convertida for de origem ISET, enfileira o evento "em_fabricacao"
    if (enrichedData.source === "n8n") {
      try {
        const orderNum = orderPayload.order_number || "AVULSO";
        isetSyncService.enqueueEvent("em_fabricacao", orderNum, newOrder.id);
      } catch (err) {
        console.error("Erro ao enfileirar sincronização ISET na conversão:", err);
      }
    }

    // 3. DEBITAR DO ESTOQUE (Se aplicável)
    if (stockItemId) {
      const updateData = {
        status: "adjusted_out",
        dateOut: new Date(),
        removedBy: "Sistema (Conversão)",
        reason: fromStock ? "converted_to_order" : "intercepted_for_order",
      };

      // Se for PE Interceptado OU Estoque Físico, removemos a flag isPE
      // para ele sair da contagem de fábrica.
      if (fromStock || isInterceptedPE) {
        updateData.isPE = false;
      }

      if (isInterceptedPE) {
        updateData.linkedOrderNumber = orderPayload.order_number;
      }

      // Update no Inventory
      await pb.collection("inventory_items").update(stockItemId, updateData);
    }

    // 4. Deletar a Reserva Original
    await pb.collection("reservations").delete(oldReservationId);

    // 5. [Fase 6] Dedução de Insumos da Receita BOM (Fail-safe e Atômico)
    try {
      if (fromStock || isInterceptedPE) {
        console.log(`[BOM] Item proveniente do Estoque ou Fábrica de Estoque Interceptado (fromStock: ${fromStock}, isInterceptedPE: ${isInterceptedPE}). Ignorando dedução de receita BOM para evitar duplicidade.`);
      } else if (enrichedData.sku) {
        const sku = enrichedData.sku.toUpperCase().trim();
        const orderQty = Number(enrichedData.quantity) || 1;

        console.log(`[BOM] Procurando receita para o SKU: ${sku} (Qtd do pedido: ${orderQty})`);
        const recipe = await bomService.getRecipe(sku);

        if (recipe && recipe.length > 0) {
          console.log(`[BOM] Receita encontrada com ${recipe.length} itens. Iniciando deduções atômicas...`);
          
          await Promise.all(recipe.map(async (item) => {
            const supplyId = item.supply_id;
            const qtyPerUnit = Number(item.quantity_per_unit) || 0;
            const totalDeduct = qtyPerUnit * orderQty;

            if (supplyId && totalDeduct > 0) {
              let deductValue = totalDeduct;
              try {
                const supply = await pb.collection("supplies").getOne(supplyId);
                if (supply && supply.stone_properties) {
                  let props = supply.stone_properties;
                  if (typeof props === "string") {
                    try {
                      props = JSON.parse(props);
                    } catch (e) {}
                  }
                  if (props && props.is_stone) {
                    const avgWeight = Number(props.peso_medio_pedra) || 0;
                    deductValue = totalDeduct * avgWeight;
                    console.log(`[BOM] Insumo é pedra: convertendo ${totalDeduct} unidades para ${deductValue} ct (peso médio por pedra: ${avgWeight})`);
                  }
                }
              } catch (err) {
                console.error(`[BOM] Falha ao obter dados adicionais do insumo ${supplyId}, deduzindo valor bruto.`, err);
              }

              console.log(`[BOM] Deduzindo ${deductValue} do insumo ${supplyId} (Receita: ${qtyPerUnit} por unidade)`);
              // Decremento atômico unário via PocketBase
              await pb.collection("supplies").update(supplyId, {
                "current_quantity+": -deductValue,
              });
            }
          }));
          console.log(`[BOM] Todas as deduções atômicas concluídas com sucesso para o SKU ${sku}!`);
        } else {
          console.log(`[BOM] Nenhuma receita BOM cadastrada para o SKU ${sku}. Nenhuma dedução realizada.`);
        }
      }
    } catch (bomError) {
      // ISOLAMENTO TOTAL: Qualquer falha na baixa de insumos (receita incompleta, timeout de rede, etc.)
      // é capturada silenciosamente e apenas printada nos logs. O pedido principal NÃO é prejudicado!
      console.error("[BOM - CRÍTICO] Erro capturado silenciosamente na dedução BOM:", bomError);
    }

    console.log("✅ Conversão realizada no PocketBase!");
    return newOrder.id;
  },

  // --- 2. DELETAR EM MASSA ---
  async deleteReservations(ids) {
    if (!ids || ids.length === 0) return;

    // Deleta um por um (PocketBase não tem deleteBatch ainda via SDK cliente)
    const promises = ids.map(id => pb.collection("reservations").delete(id));
    await Promise.all(promises);
  },

  // --- 3. CRIAR RESERVA (Simples) ---
  async createReservation(data) {
    // Normaliza dados para o PB
    const payload = {
      sku: data.sku,
      quantity: Number(data.quantity),
      status: "PENDENTE",
      notes: data.notes || "",
      created_by_name: data.createdBy || "Sistema",
      source: data.source || "manual", // Identifica a origem (Ícone Bot vs Caneta)

      // Flattened Fields
      customer_name: data.order?.customer?.name || data.customerName || "Cliente",

      // JSON Completo (Para compatibilidade com ReservationsTab.js)
      order_metadata: data.order || { customer: { name: data.customerName || "Cliente" } },
      specs: { ...(data.specs || {}), exception: data.exception || "" }, // Salva dentro de specs para garantir que o PB não drope se a coluna raiz não existir
      exception: data.exception || "", // <--- Mantém na raiz por precaução
    };

    const record = await pb.collection("reservations").create(payload);

    // Gatilho Financeiro
    try {
      const orderNum = record.order_metadata?.number || record.order?.number || "S/N";
      const customerName = record.order_metadata?.customer?.name || record.customer_name || "Cliente Balcão";
      const rawVal = record.order_metadata?.payment?.total || 0;
      let orderValCents = 0;
      if (typeof rawVal === "number") {
        orderValCents = Math.round(rawVal * 100);
      } else if (typeof rawVal === "string") {
        const clean = rawVal.replace("R$", "").replace(/\./g, "").replace(",", ".").trim();
        orderValCents = Math.round(parseFloat(clean) * 100) || 0;
      }

      await financeiroIntegracaoService.triggerPendingTransaction({
        origem: "reservations",
        origemId: record.id,
        snapshot: record,
        dataSugerida: new Date(record.created || new Date()).toISOString().split("T")[0],
        valorSugeridoCentavos: orderValCents,
        descricaoSugerida: `Reserva Pedido ${orderNum} - Cliente: ${customerName}`,
        tipoPendencia: "entrada"
      });
    } catch (errFin) {
      console.warn("Erro ao gerar pendência financeira para Reserva:", errFin);
    }
  },

  // --- 4. ATUALIZAR RESERVA (Sem Converter) ---
  async updateReservation(id, data) {
    if (!id) throw new Error("ID da reserva ausente para atualização.");

    const payload = {
      sku: data.sku,
      notes: data.notes || data.order?.notes || "",
      customer_name: data.order?.customer?.name || data.customerName || "Cliente",
      
      // JSON Completos
      order_metadata: data.order || {},
      specs: { ...(data.specs || {}), exception: data.exception || "" }, // Garante o salvamento via campo JSON
      shipping: data.shipping || {},
      exception: data.exception || "", // <--- Mantém na raiz por precaução

      // Data ajustada no Modal
      customCreatedAt: data.customCreatedAt ? new Date(data.customCreatedAt) : undefined,
    };

    return await pb.collection("reservations").update(id, payload);
  },

  // --- 5. VERIFICAÇÃO DE PENDÊNCIA (Para evitar duplicidade ou alertar) ---
  async hasPendingReservations(sku) {
    if (!sku) return false;

    const result = await pb.collection("reservations").getList(1, 1, {
      filter: `sku="${sku}"`,
    });

    return result.items.length > 0;
  }
};
